export default __webpack_public_path__ + "static/media/Nuvem shop.99684377.svg";